// Where in Microsoft's admin portals a finding is fixed: the portal and the menu path, shown in the side panel as "Ret det i ...".
// Only the portal's front page is linked (Microsoft keeps changing the deep links); the path is plain text. NordComply changes
// nothing itself. A finding without an entry here simply shows no "Ret det i" block. Keyed by the finding key (useFindingGroups).
// The paths are Microsoft's own English menu names and should be checked against the portals now and then.
const ENTRA = { portal: 'Entra ID', url: 'https://entra.microsoft.com' };
const INTUNE = { portal: 'Intune', url: 'https://intune.microsoft.com' };
const DEFENDER = { portal: 'Defender', url: 'https://security.microsoft.com' };
const EXCHANGE = { portal: 'Exchange admin', url: 'https://admin.exchange.microsoft.com' };
const M365 = { portal: 'Microsoft 365 admin', url: 'https://admin.microsoft.com' };
const SHAREPOINT = { portal: 'SharePoint admin', url: 'https://admin.microsoft.com/sharepoint' };

const MFA = { ...ENTRA, path: ['Users', 'All users', 'Authentication methods'] };
const ADMIN_ROLES = { ...ENTRA, path: ['Roles & admins', 'All roles'] };
const CA = { ...ENTRA, path: ['Protection', 'Conditional Access', 'Policies'] };
const APPS = { ...ENTRA, path: ['Enterprise applications', 'All applications'] };
const MAILBOXES = { ...EXCHANGE, path: ['Recipients', 'Mailboxes'] };
const SITES = { ...SHAREPOINT, path: ['Sites', 'Active sites'] };
const INCIDENTS = { ...DEFENDER, path: ['Incidents & alerts', 'Incidents'] };

export const FIX_PATH = {
  'id-mfa': MFA,
  'id-old-password': MFA,
  'id-weak-mfa': MFA,
  'roller-no-mfa': MFA,
  'id-risky': { ...ENTRA, path: ['Protection', 'Identity Protection', 'Risky users'] },
  'id-disabled-licensed': { ...M365, path: ['Users', 'Active users', 'Licenses and apps'] },
  'id-inactive': { ...ENTRA, path: ['Users', 'All users'] },
  'id-guests': { ...ENTRA, path: ['Users', 'All users', 'Guest users'] },
  'roller-guest-admin': ADMIN_ROLES,
  'roller-inactive-admin': ADMIN_ROLES,
  'roller-app-admin': ADMIN_ROLES,
  'roller-global': ADMIN_ROLES,
  'roller-other': ADMIN_ROLES,
  'ca-disabled': CA,
  'ca-report': CA,
  'enheder-Mangler kryptering': { ...INTUNE, path: ['Endpoint security', 'Disk encryption'] },
  'enheder-For gammel OS-version': { ...INTUNE, path: ['Devices', 'Windows', 'Update rings'] },
  'enheder-Defender ikke onboardet': { ...INTUNE, path: ['Endpoint security', 'Microsoft Defender for Endpoint'] },
  'enheder-Fejlet compliance-politik': { ...INTUNE, path: ['Devices', 'Compliance'] },
  'enheder-Compliance-afvigelse': { ...INTUNE, path: ['Devices', 'Compliance'] },
  'enheder-afviger': { ...INTUNE, path: ['Devices', 'Compliance'] },
  'sik-risky-signin': { ...ENTRA, path: ['Protection', 'Identity Protection', 'Risky sign-ins'] },
  'sik-failed-signins': { ...ENTRA, path: ['Monitoring & health', 'Sign-in logs'] },
  'sik-legacy-auth': CA,
  'sik-stale-open': INCIDENTS,
  'sik-high': INCIDENTS,
  'sik-other': INCIDENTS,
  'app-secret-expired': { ...ENTRA, path: ['App registrations', 'Certificates & secrets'] },
  'app-secret-expiring': { ...ENTRA, path: ['App registrations', 'Certificates & secrets'] },
  'app-write-all': APPS,
  'app-unverified': APPS,
  'app-priv': APPS,
  'app-unused': APPS,
  'exchange-domain-missing': { ...M365, path: ['Settings', 'Domains', 'DNS records'] },
  'exchange-domain-weak': { ...M365, path: ['Settings', 'Domains', 'DNS records'] },
  'exchange-shared-signin': { ...M365, path: ['Teams & groups', 'Shared mailboxes'] },
  'exchange-near-full': MAILBOXES,
  'exchange-forward': MAILBOXES,
  'exchange-orphaned-access': MAILBOXES,
  'sp-guests-stale': SITES,
  'sp-guests': { ...SHAREPOINT, path: ['Policies', 'Sharing'] },
  'sp-public': SITES,
  'sp-quota': SITES,
  'sp-inactive': SITES,
  'sp-no-owner': SITES,
  'lic-unused': { ...M365, path: ['Billing', 'Licenses'] },
};

export const fixPathFor = (key) => FIX_PATH[key] || null;
